const uiFriendlyRoles = {
  performer: 'Performer',
  approver: 'Approver',
  reviewer: 'Reviewer',
  customer: 'Customer',
};

const uiFriendlyRolesAccessors = (role) => {
  switch (role) {
    case 'perform':
      return uiFriendlyRoles.performer;
    case 'approve':
      return uiFriendlyRoles.approver;
    case 'review':
      return uiFriendlyRoles.reviewer;
    case 'customer':
      return uiFriendlyRoles.customer;
    default:
      return uiFriendlyRoles.customer;
  }
};

export { uiFriendlyRolesAccessors };
